import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import UserSettings from '@/data/models/domain/UserSettings'

@RepoSettings<Endpoint>({
  model: UserSettings,
})
@injectable()
@injectFromBase()
export default class UserSettingsRepository extends OrmApiRepository<UserSettings> {
  public async fetchEmailPrice() {
    const path = this.endpointsService.getPath('emailCampaignPricing')
    const response = await this.getApiSource().get<{ price: number }>(path)
    return response.data.price
  }
}
